import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import img_cross from "@/assets/img/img_cross.png";

import { toggleTicketRow } from "@/modules/commonUnsubmittedTicket";
import {
	ITicketTableProps,
	ITicketTableState,
	ShioAnimals
} from "@/types/GlobalTypes";

import nary from "@/modules/nary";

export default class ShioBallsTable extends React.Component<ITicketTableProps, ITicketTableState> {
	state = { expandedRows: {} };

	render() {
		const { activeGame, langdata } = this.props;
		const activeBetGroup = activeGame.activeBetGroup;

		return (
			<div className="table-unsubmitted-tickets"
				{...{
					betgroup: activeBetGroup,
					pcode: "m29"
				}}>
				{
					this.props.mobile ? (
						<div className="header">
							{
								((group) => {
									if (!group)
										return "";

									switch (group) {
										case "c3set": return "C3 Set";
										case "3dset": return "3D Set";
										default: break;
									}

									if (group[0] === "c")
										return "Colok " + group[1] + "D";

									if (group[0] === "d")
										return group[1] + "D";

									return "";
								})(activeBetGroup)
							}
						</div>
					) : null
				}

				<div className="scrollable-area">
					<table>
						<thead>
							{
								activeBetGroup ? (
									<tr>
										<td />
										<td>{langdata["txt_guess"]}</td>
										<td>{langdata["txt_bet"]}</td>
									</tr>
								) : null
							}
						</thead>

						<tbody>
							{
								activeBetGroup &&
								activeGame.groupedUnsubmittedTickets[activeBetGroup].map((item, idx) => {
									// console.log("MMG item", item)
									// const betNum = item.animals.slice(0).filter(item => item !== "").join(",");
									const betGroup = activeBetGroup;

									const isColok = betGroup[0] === "c";
									const isSet = betGroup.indexOf("set") >= 0;

									const maximumAnimalCount = isSet ? 3 : Number(betGroup[1]);

									const animalArray = item.animals.slice(0);

									//Empty number check
									const hasEmptyAnimalArray = activeGame.activeUnsubmittedTicketRow === idx &&
										animalArray.filter(animal => animal !== null).length === 0;

									//Empty bet check
									const hasEmptyBet = activeGame.activeUnsubmittedTicketRow === idx &&
										activeGame.groupedUnsubmittedTickets[activeBetGroup]
											[activeGame.activeUnsubmittedTicketRow].bet === 0;

									const animalRowFunction = (animal: ShioAnimals, animalIdx: number) =>
										animal ? (
											<div key={"aRF_" + animalIdx}>
												{assetImg("m29", animal + ".svg", "m29_" + idx + "_" + animalIdx)}

												<img className="delete"
													src={img_cross}

													{...{
														pcode: activeGame.pcode,
														ticketindex: idx,
														animalindex: animalIdx
													}}

													onClick={this.props.removeAnimal}
													alt={"ball " + animal}
												/>
											</div>
										) : (
												//Checks for colok and empty animal circles
												(3 - animalIdx > maximumAnimalCount) ?
													(
														//Displays cross emoji
														!isColok ?
															<div key={"aRF_" + animalIdx}
																className="empty">
																<img src={img_cross} alt="Not allowed" />
															</div> : <div key={"aRF_" + animalIdx} />
													) : <div key={"aRF_" + animalIdx}
															 className="empty" />
											);

									//Set derivatives
									const animalRowFunctionNoDeleteButton = (animal: ShioAnimals, animalIdx: number) =>
										animal ? (
											<div key={"aRFNDB_" + animalIdx}>
												{assetImg("m29", animal + ".svg", "m29_" + idx + "_" + animalIdx)}
											</div> 
										) : (!animal && !isColok) ? (
											<div key={"aRFNDB_" + animalIdx}
												 className="empty">
												<img src={img_cross} alt="Not allowed" />
											</div>
										) : (
											<div key={"aRFNDB_" + animalIdx}
												 className="empty" />
										);

									let animalArrayCopy: ShioAnimals[][];
									if (isSet) {
										animalArrayCopy = [animalArray.slice(1), animalArray.slice(2)];
										animalArrayCopy[0].unshift(null);
										animalArrayCopy[1].unshift(null, null);
									}

									//C3 Set and 3D Set
									return isSet ? [
										//Set first row
										<tr key={"MMG_m29_uT_" + idx + 0}

											className={activeGame.activeUnsubmittedTicketRow === idx ? "active" : ""}

											{...{
												//to activate row
												pcode: activeGame.pcode,
												rowidx: idx
											}}
											onClick={this.props.activateUnsubmittedTicketRow}>

											{ /* Ticket Number Column */}
											<td>
												<div className="ticket-index">
													{idx + 1}
												</div>
											</td>

											{/* Guess column */}
											<td className={hasEmptyAnimalArray ? "empty-guess" : ""}>
												{
													animalArray.map(animalRowFunction)
												}

												{
													//Toggle Arrow
												}
												<div className="toggle-child"
													{...{index: idx}}
													onClick={toggleTicketRow.bind(this)}>

													<i className="fas fa-caret-down" />
												</div>
											</td>

											{/* Bet column */}
											<td className={"sl-bet" +
												(hasEmptyBet ? " blink" : "")}

												key={activeGame.pcode + "_" + activeBetGroup + "_" + idx}

												{...{
													index: idx,
													group: betGroup,
													pcode: activeGame.pcode
												}}
												onClick={this.props.insertBet}
											>
												<div className="bet-label">
													{item.bet}
												</div>

												{/* Remove Bet button */}
												<img className="delete"
													src={img_cross}

													{...{
														pcode: activeGame.pcode,
														ticketindex: idx,
														group: activeBetGroup
													}}

													onClick={this.props.removeBet}
													alt={"bet " + idx}
												/>
											</td>
										</tr>,

										//Set Children
										//no need to use complex interactions
										...this.state.expandedRows[idx] ? (
											nary(2).map(num =>
												<tr key={"MMG_m29_uT_" + idx + "_" + num}>
													<td />

													{/* Guess column */}
													<td>
														{
															animalArrayCopy[num - 1].map(animalRowFunctionNoDeleteButton)
														}
													</td>

													{/* Bet column */}
													<td>
														<div className="bet-label">
															{item.bet}
														</div>
													</td>
												</tr>											
											)
										) : []
									] : (
											//Not Set
											<tr key={"MMG_m29_uT_" + idx}

												className={activeGame.activeUnsubmittedTicketRow === idx ? "active" : ""}

												{...{
													//to activate row
													pcode: activeGame.pcode,
													rowidx: idx
												}}

												onClick={this.props.activateUnsubmittedTicketRow}>

												<td>
													<div className="ticket-index">
														{idx + 1}
													</div>
												</td>

												{/* Guess column */}
												<td className={hasEmptyAnimalArray ? "empty-guess" : ""}>
													{
														item.animals.slice(0)
															.map(animalRowFunction)
													}
												</td>

												{/* Bet column */}
												<td className={"sl-bet" +
													(hasEmptyBet ? " blink" : "")}
													key={activeGame.pcode + "_" + activeBetGroup + "_" + idx}

													{...{
														index: idx,
														group: betGroup,
														pcode: activeGame.pcode
													}}

													onClick={this.props.insertBet}
												>
													<div className="bet-label">
														{item.bet}
													</div>

													{/* Remove Bet button */}
													<img className="delete"
														src={img_cross}

														{...{
															pcode: activeGame.pcode,
															ticketindex: idx,
															group: activeBetGroup
														}}

														onClick={this.props.removeBet}
														alt={"bet " + idx}
													/>
												</td>
											</tr>
										);
								})
							}

							{
								!activeBetGroup ?
									<tr key={"MMG_m26_uT_choose"}>
										<td>
											{this.props.langdata["txt_choose_bet_type"]}
										</td>
									</tr>


									//Empty Unsubmitted Tickets
									: (
										<tr key={"MMG_m26_uT_add"}
											{...{ pcode: activeGame.pcode }}
											onClick={this.props.addUnsubmittedTicketRow}

											className="add-ticket">
											<td colSpan={3}>
												{this.props.langdata["txt_add_tickets"]}
											</td>
										</tr>
									)
							}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}